import Request from '@/plugins/request'

export function getOrders(params) {
  return Request.get('order-offline', {
    params,
  })
}

export function createOrder() {
  return Request.get(`order-offline/create`)
}

export function storeOrder(data) {
  return Request.post('order-offline', data)
}

// 退单
export function refuseOrder(order_id, data) {
  return Request.post(`order-offline/${order_id}/refuse`, data)
}

// 修改发货状态
export function modifyDeliveryStatus(order_id, data) {
  return Request.post(`order-offline/${order_id}/delivery-status`, data)
}

// 更新物流信息
export function modifyDeliveryStatusExpress(order_id, data) {
  return Request.post(`order-offline/${order_id}/delivery-express`, data)
}

export function updateOrder(id, data) {
  return Request.put(`order-offline/${id}`, data)
}

// 打印清单
export function editOrder(id) {
  return Request.get(`order-offline/${id}/edit`)
}

// export function destroyOrder(id) {
//   return Request.delete(`order-offline/${id}`)
// }

export function exportOrder(params) {
  return Request.get('order-offline/export', {params})
}

// 物流信息
export function expressOrder(order_id) {
  return Request.post(`order-offline/${order_id}/express`)
}

// 订单导入信息
export function importOrder(data) {
  return Request.post(`order-offline/import`, data)
}

// 订单导入信息-地址解析
export function importAddressParse(data) {
  return Request.post(`order-offline/import/address-parse`, data)
}

// 订单导入信息-订单信息解析
export function importOrderItemParse(data) {
  return Request.post(`order-offline/import/order-item-parse`, data)
}

// 打印小票
export function printerOrder(order_id) {
  return Request.post(`order-offline/${order_id}/printer`)
}
